var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.post)?_c('Article',{class:_vm.specialClasses,attrs:{"post":_vm.post,"display-shortened-content":_vm.$store.getters['paywall/displayShortenedContent'],"is-free":_vm.post.isFree,"role":"main","page-settings":_vm.pageSettings}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }